import { PropsWithChildren, ReactElement } from 'react';
import { Stack } from '@mui/material';

/**
 * The label beside a switch in a PALO mask. MUI's own is body text, which next
 * to a 24-pixel switch in a section head read a size larger than everything
 * around it.
 */
export const PaloSwitchLabel = ({ children }: PropsWithChildren): ReactElement => (
    <Stack
        direction="row"
        alignItems="center"
        gap="4px"
        sx={{
            fontSize: '12.5px',
            fontWeight: 500,
            letterSpacing: 'normal',
            // The section head sets both, and a switch label is neither.
            textTransform: 'none',
            color: 'text.primary',
            '& svg': { fontSize: 16 },
        }}
    >
        {children}
    </Stack>
);
